import { IPromise } from 'angular';
import { PackageRepository } from '../package-repository.service/package-repository';
import { IDjangoPackage } from '../../tn.common';

export class LocalPackages {
    protected _packagesPromise: IPromise<IDjangoPackage[]> = this._fetchPackages();

    static $inject = ['packageRepository'];

    constructor(protected packageRepository: PackageRepository) {}

    protected _fetchPackages(): IPromise<IDjangoPackage[]> {
        return this.packageRepository.list().then((res) => res.results);
    }

    getPackages(): IPromise<IDjangoPackage[]> {
        return this._packagesPromise;
    }
}
